import React, { useState } from "react";

export default function RedFlagAlerts({
    title = "Red flags today",
    alerts = [],
    categories = ["All", "Clinical", "Logistics", "Follow-up"],
}) {
    const [selectedCategory, setSelectedCategory] = useState("All");

    const filteredAlerts =
        selectedCategory === "All"
            ? alerts
            : alerts.filter((a) => a.category === selectedCategory);

    return (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-3 py-3 w-full">

            {/* Header Row */}
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold text-slate-800">{title}</h3>

                <div className="flex items-center gap-3">
                    {/* Alert count badge */}
                    <span className="px-2 py-0.5 text-xs rounded-full bg-red-100 text-red-700 border border-red-200">
                        {alerts.length} alerts
                    </span>

                    {/* Dropdown filter */}
                    <select
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        className="text-xs border border-slate-300 rounded-lg px-2 py-1 bg-white focus:ring-2 focus:ring-blue-500"
                    >
                        {categories.map((c, i) => (
                            <option key={i} value={c}>
                                {c}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Alerts List */}
            <div className="space-y-3 text-sm">

                {filteredAlerts.length === 0 ? (
                    <div className="text-xs text-slate-500 py-4 text-center">
                        No alerts for this category.
                    </div>
                ) : (
                    filteredAlerts.map((alert, idx) => (
                        <div key={idx} className="flex items-start gap-2">

                            {/* Bullet Indicator */}
                            <span
                                className={`mt-1 w-2 h-2 rounded-full ${alert.severity === "high"
                                        ? "bg-red-500"
                                        : alert.severity === "medium"
                                            ? "bg-amber-500"
                                            : "bg-blue-500"
                                    }`}
                            ></span>

                            {/* Text */}
                            <p className="text-xs text-slate-700 leading-4 flex-1">
                                {alert.message}
                            </p>

                        </div>
                    ))
                )}

            </div>
        </div>
    );
}
